
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/listings/details/[id]",
      function () {
        return require("private-next-pages/buy/listings/details/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/listings/details/[id]"])
      });
    }
  